export const saveItemLocalStore = (key: string, val: any)=>{
    localStorage.setItem(key, JSON.stringify(val));
}

export const getItemLocalStore = (key: string)=>{
    const item = localStorage.getItem(key);
    return item ? JSON.parse(item): {};
}

export const cleanLocalStore = ()=>{
    localStorage.clear();
}